import { inject, injectable } from 'inversify'
import {
  DeleteMyOfferUseCaseInput,
  DeleteMyOfferUseCaseOutput,
  IAppErrorFactory,
  IOffersService,
  IDeleteMyOfferUseCase,
} from '../../types'
import symbols from '../../symbols'

@injectable()
export default class DeleteMyOfferInteractor implements IDeleteMyOfferUseCase {
  @inject(symbols.IOffersService) private offersService: IOffersService

  @inject(symbols.IAppErrorFactory) private errorFactory: IAppErrorFactory

  async handle(input: DeleteMyOfferUseCaseInput): Promise<DeleteMyOfferUseCaseOutput> {
    const output = this.getDefaultOutputData()
    try {
      output.offer = await this.offersService.deleteMyOffer({
        id: input.id,
      })
    } catch (e) {
      output.error = this.errorFactory.create({
        originalInstance: e as Error,
      })
    }

    return output
  }

  private getDefaultOutputData(): DeleteMyOfferUseCaseOutput {
    return {
      offer: null,
      error: null,
    }
  }
}
